import { Controller } from "stimulus"

/**
 * Toggles the submit button text based on the portal visibility checkbox.
 * When "Show on portal" is checked, the button says "Upload and Notify Applicant".
 * When unchecked, the button says "Upload Document".
 */
export default class extends Controller {
  static get targets() {
    return ["checkbox"]
  }

  connect() {
    if (this.hasCheckboxTarget) {
      this.toggle()
    }
  }

  toggle() {
    if (!this.hasCheckboxTarget) return

    const submitButton = this.element.querySelector("[type='submit']")
    if (!submitButton) return

    if (this.checkboxTarget.checked) {
      submitButton.value = "Upload and Notify Applicant"
    } else {
      submitButton.value = "Upload Document"
    }
  }
}
